export const isValidEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  const trimmed = email.trim();
  return /\S+@\S+\.\S+/.test(trimmed);
};

export const passwordPolicy = {
  minLength: 8,
  requireUpper: true,
  requireLower: true,
  requireDigit: true,
  requireSpecial: true,
};

export const isStrongPassword = (pwd) => {
  if (!pwd || typeof pwd !== 'string') return false;
  const { minLength, requireUpper, requireLower, requireDigit, requireSpecial } = passwordPolicy;
  const lengthOk = pwd.length >= minLength;
  const upperOk = !requireUpper || /[A-Z]/.test(pwd);
  const lowerOk = !requireLower || /[a-z]/.test(pwd);
  const digitOk = !requireDigit || /\d/.test(pwd);
  const specialOk = !requireSpecial || /[^A-Za-z0-9]/.test(pwd);
  return lengthOk && upperOk && lowerOk && digitOk && specialOk;
};

export const passwordRequirementStatus = (pwd) => {
  const { minLength, requireUpper, requireLower, requireDigit, requireSpecial } = passwordPolicy;
  return {
    length: (pwd || '').length >= minLength,
    upper: !requireUpper || /[A-Z]/.test(pwd || ''),
    lower: !requireLower || /[a-z]/.test(pwd || ''),
    digit: !requireDigit || /\d/.test(pwd || ''),
    special: !requireSpecial || /[^A-Za-z0-9]/.test(pwd || ''),
  };
};